<template>
  <dashboard>
    <template v-slot:content>
      <loading v-show="!loading" />
      <section>
        <b-container fluid>
          <div class="header-elements align-items-center">
            <b-row class="mt-2">
              <b-col lg="12" md="12">
                <b-row class>
                  <b-col lg="8" md="8">
                    <div class="d-flex align-items-center">
                      <h5 class="mt-2 mr-3" v-text="Title"></h5>
                      <b-badge
                        :variant="'danger'"
                        class="px-2 py-1 mt-1 search-term-badge"
                        v-if="showSearchTerm && state.system.isOffline"
                        id="clear-search"
                      >
                        Clear Search
                        <font-awesome-icon
                          style="cursor: pointer;"
                          @click="clearSearch"
                          :icon="['fas', 'times']"
                        />
                      </b-badge>
                    </div>
                  </b-col>
                  <b-col lg="4" md="4">
                    <b-input-group>
                      <b-input-group-text slot="prepend" class="search-icon">
                        <font-awesome-icon :icon="['fas', 'search']" />
                      </b-input-group-text>
                      <b-form-input
                        v-model.trim="search"
                        placeholder="Search Invoices (Press enter to search)"
                        v-on:keyup.enter="(pageNo = 1), searchbar()"
                        class="search"
                        autocomplete="off"
                        :disabled="$loading"
                        v-shortkey.focus="['ctrl', 's']"
                        autofocus
                        id="invoice-search"
                      ></b-form-input>
                    </b-input-group>
                  </b-col>
                  <!-- <b-col lg="2" md="2" class="pl-1">
                    <b-button
                      :class="
                        isContentShow == false
                          ? 'w-100 grey-btn'
                          : 'w-100 btn-danger'
                      "
                      v-on:click="isContentShow = !isContentShow"
                      :disabled="state.system.isOffline"
                      >{{
                        isContentShow == false ? "View Filter" : "Hide Filter"
                      }}</b-button
                    >
                  </b-col> -->
                </b-row>
              </b-col>
            </b-row>
            <!-- New invoice search starts-->
            <b-row class="mt-2" v-if="!state.system.isOffline">
              <b-col lg="8">
                <b-modal
                  ref="date-range"
                  hide-footer
                  centered
                  title="Select Date Range"
                  @hide="checkDateFilter"
                >
                  <div class="d-block">
                    <b-row>
                      <b-col>
                        <label for>Start Date</label>
                        <datepicker
                          placeholder="Select Date"
                          input-class="form-control"
                          v-model="startDate"
                        />
                      </b-col>
                      <b-col>
                        <label for>End Date</label>
                        <datepicker
                          placeholder="Select Date"
                          input-class="form-control"
                          v-model="endDate"
                        />
                      </b-col>
                    </b-row>
                  </div>

                  <b-button
                    class="mt-4 float-right"
                    variant="primary"
                    @click="$refs['date-range'].hide()"
                    :disabled="endDate == ''"
                    id="apply-filter-date"
                  >
                    Apply Filter
                  </b-button>
                </b-modal>
                <b-modal
                  ref="spec-month"
                  hide-footer
                  centered
                  title="Select Specific Month"
                  @hide="checkDateFilter"
                >
                  <div class="d-block">
                    <b-row>
                      <b-col>
                        <label for>Select Month</label>
                        <datepicker
                          placeholder="Select Month"
                          input-class="form-control"
                          v-model="specMonth"
                          :minimumView="'month'"
                          :maximumView="'month'"
                        />
                      </b-col>
                    </b-row>
                  </div>

                  <b-button
                    class="float-right mt-4"
                    variant="primary"
                    @click="$refs['spec-month'].hide()"
                    :disabled="specMonth == ''"
                    id="apply-filter-month"
                  >
                    Apply Filter
                  </b-button>
                </b-modal>
                <b-modal
                  ref="spec-year"
                  hide-footer
                  centered
                  size="sm"
                  title="Select Specific Year"
                  @hide="checkDateFilter"
                >
                  <div class="d-block">
                    <b-row>
                      <b-col>
                        <label for>Select Year</label>
                        <datepicker
                          placeholder="Select Year"
                          input-class="form-control"
                          v-model="specYear"
                          :minimumView="'year'"
                          :maximumView="'year'"
                        ></datepicker>
                      </b-col>
                    </b-row>
                  </div>

                  <b-button
                    class="float-right mt-4"
                    variant="primary"
                    @click="$refs['spec-year'].hide()"
                    :disabled="specYear == ''"
                    id="apply-filter-year"
                  >
                    Apply Filter
                  </b-button>
                </b-modal>
                <b-modal
                  ref="spec-day"
                  hide-footer
                  centered
                  title="Select Specific Day"
                  @hide="checkDateFilter"
                >
                  <div class="d-block">
                    <b-row>
                      <b-col>
                        <label for>Select Day</label>
                        <datepicker
                          placeholder="Select Day"
                          input-class="form-control"
                          v-model="specDay"
                          :minimumView="'day'"
                          :maximumView="'day'"
                        ></datepicker>
                      </b-col>
                    </b-row>
                  </div>
                  <b-button
                    class="float-right mt-4"
                    variant="primary"
                    @click="$refs['spec-day'].hide()"
                    :disabled="specDay == ''"
                    id="apply-filter-day"
                  >
                    Apply Filter
                  </b-button>
                </b-modal>
                <FilterButton :searchAble="false" :closeOnClick="true">
                  <template slot="btn">
                    Date:&nbsp;
                    <span v-if="Object.keys(requestFilter.date).length == 0">
                      All</span
                    >
                    <span v-else v-text="dateFilterLabel"></span>
                  </template>
                  <template slot="body">
                    <ul class="m-0 filter-dropdown">
                      <li v-for="(options, i) in filter.date" :key="i">
                        <label
                          class="w-100 d-flex justify-content-between align-item-center custom-check-two"
                        >
                          {{ options.name }}
                          <input
                            type="checkbox"
                            :value="options"
                            @change="getFilterData('date', options)"
                            :checked="requestFilter.date == options"
                          />
                          <span class="checkmark"></span>
                        </label>
                      </li>
                    </ul>
                  </template>
                </FilterButton>
                <FilterButton :searchAble="false" :closeOnClick="true">
                  <template slot="btn">
                    Status:&nbsp;
                    <span v-if="Object.keys(requestFilter.status).length == 0">
                      All</span
                    >
                    <span v-else v-text="requestFilter.status.name"></span>
                  </template>
                  <template slot="body">
                    <ul class="m-0 filter-dropdown">
                      <li v-for="(options, i) in filter.status" :key="i">
                        <label
                          class="w-100 d-flex justify-content-between align-item-center custom-check-two"
                        >
                          {{ options.name }}
                          <input
                            type="checkbox"
                            :value="options.name"
                            @change="getFilterData('status', options)"
                            :checked="requestFilter.status == options"
                          />
                          <span class="checkmark"></span>
                        </label>
                      </li>
                    </ul>
                  </template>
                </FilterButton>
                <FilterButton :searchAble="false" :closeOnClick="true">
                  <template slot="btn">
                    MOP:&nbsp;
                    <span v-if="Object.keys(requestFilter.mop).length == 0">
                      All
                    </span>
                    <span v-else v-text="requestFilter.mop.code"></span>
                  </template>
                  <template slot="body">
                    <ul class="m-0 filter-dropdown">
                      <li v-for="(options, i) in filter.mop" :key="i">
                        <label
                          class="w-100 d-flex justify-content-between align-item-center custom-check-two"
                        >
                          {{ options.code }}
                          <input
                            type="checkbox"
                            :value="options"
                            @change="getFilterData('mop', options)"
                            :checked="requestFilter.mop == options"
                          />
                          <span class="checkmark"></span>
                        </label>
                      </li>
                    </ul>
                  </template>
                </FilterButton>
                <FilterButton :searchAble="false" :closeOnClick="true">
                  <template slot="btn">
                    Sort by:&nbsp;
                    <span v-if="Object.keys(requestFilter.sort).length == 0">
                      Newest First</span
                    >
                    <span v-else v-text="requestFilter.sort.name"></span>
                  </template>
                  <template slot="body">
                    <ul class="m-0 filter-dropdown">
                      <li v-for="(options, i) in filter.sort" :key="i">
                        <label
                          class="w-100 d-flex justify-content-between align-item-center custom-check-two"
                        >
                          {{ options.name }}
                          <input
                            type="checkbox"
                            :value="options"
                            @change="getFilterData('sort', options)"
                            :checked="
                              requestFilter.sort.key == options.key ||
                                (Object.keys(requestFilter.sort).length == 0 &&
                                  options.key == 'new')
                            "
                          />
                          <span class="checkmark"></span>
                        </label>
                      </li>
                    </ul>
                  </template>
                </FilterButton>
              </b-col>
              <b-col lg="4" class="text-right">
                <b-button
                  variant="danger"
                  :disabled="$loading || isClearShow"
                  size="sm"
                  style="padding:0.525rem 1rem"
                  @click="clearSearch"
                  id="reset-filter"
                  >Reset Filter</b-button
                >
                <b-button
                  variant="primary"
                  :disabled="$loading || filterBtnStatus"
                  class="ml-2"
                  size="sm"
                  style="padding:0.525rem 1rem"
                  id="apply-filter"
                  @click="(pageNo = 1), filterDataSearch(), filterData(0)"
                  >Apply Filter</b-button
                >
              </b-col>
            </b-row>
          </div>
        </b-container>
      </section>

      <!-- old invoice search-->
      <section
        v-show="isContentShow"
        v-if="searchInvoiceList == ''"
        class="fadein"
      >
        <b-container fluid>
          <div class="customer-info box-shadow mt-2 mb-2 p-4 bg-white">
            <b-form-group>
              <b-row>
                <b-col lg="3" class="text-left">
                  <label for class="mb-0">Filter by Date</label>
                  <b-form-select
                    v-model="requestFilter.date"
                    @change="filterData(1)"
                  >
                    <option value>Anytime</option>
                    <option
                      v-for="sort in filter.date"
                      :value="sort.key"
                      v-text="sort.name"
                      :key="sort.key"
                    ></option>
                  </b-form-select>
                  <b-modal
                    ref="date-range"
                    hide-footer
                    centered
                    title="Select Date Range"
                  >
                    <div class="d-block">
                      <b-row>
                        <b-col>
                          <label for>Start Date</label>
                          <datepicker
                            placeholder="Select Date"
                            input-class="form-control"
                            v-model="startDate"
                          ></datepicker>
                        </b-col>
                        <b-col>
                          <label for>End Date</label>
                          <datepicker
                            placeholder="Select Date"
                            input-class="form-control"
                            v-model="endDate"
                          ></datepicker>
                        </b-col>
                      </b-row>
                    </div>

                    <b-button
                      class="btn grey-btn float-right px-4 mt-4"
                      @click="filterData(0)"
                      :disabled="endDate == ''"
                      id="apply-filter-date"
                    >
                      <span v-if="$loading == false">Apply Filter</span>
                      <b-spinner small v-if="$loading == true"></b-spinner>
                    </b-button>
                  </b-modal>
                  <b-modal
                    ref="spec-month"
                    hide-footer
                    centered
                    title="Select Specific Month"
                  >
                    <div class="d-block">
                      <b-row>
                        <b-col>
                          <label for>Select Month</label>
                          <datepicker
                            placeholder="Select Month"
                            input-class="form-control"
                            v-model="specMonth"
                            :minimumView="'month'"
                            :maximumView="'month'"
                          ></datepicker>
                        </b-col>
                      </b-row>
                    </div>

                    <b-button
                      class="btn grey-btn float-right px-4 mt-4"
                      @click="filterData(0)"
                      :disabled="specMonth == ''"
                      id="apply-filter-month"
                    >
                      <span v-if="$loading == false">Apply Filter</span>
                      <b-spinner small v-if="$loading == true"></b-spinner>
                    </b-button>
                  </b-modal>
                  <b-modal
                    ref="spec-year"
                    hide-footer
                    centered
                    title="Select Specific Year"
                  >
                    <div class="d-block">
                      <b-row>
                        <b-col>
                          <label for>Select Year</label>
                          <datepicker
                            placeholder="Select Year"
                            input-class="form-control"
                            v-model="specYear"
                            :minimumView="'year'"
                            :maximumView="'year'"
                          ></datepicker>
                        </b-col>
                      </b-row>
                    </div>

                    <b-button
                      class="btn grey-btn float-right px-4 mt-4"
                      @click="filterData(0)"
                      :disabled="specYear == ''"
                      id="apply-filter-year"
                    >
                      <span v-if="$loading == false">Apply Filter</span>
                      <b-spinner small v-if="$loading == true"></b-spinner>
                    </b-button>
                  </b-modal>
                  <b-modal
                    ref="spec-day"
                    hide-footer
                    centered
                    title="Select Specific Day"
                  >
                    <div class="d-block">
                      <b-row>
                        <b-col>
                          <label for>Select Day</label>
                          <datepicker
                            placeholder="Select Day"
                            input-class="form-control"
                            v-model="specDay"
                            :minimumView="'day'"
                            :maximumView="'day'"
                          ></datepicker>
                        </b-col>
                      </b-row>
                    </div>
                    <b-button
                      class="btn grey-btn float-right px-4 mt-4"
                      @click="filterData(0)"
                      :disabled="specDay == ''"
                      id="apply-filter-day"
                    >
                      <span v-if="$loading == false">Apply Filter</span>
                      <b-spinner small v-if="$loading == true"></b-spinner>
                    </b-button>
                  </b-modal>
                </b-col>
                <b-col lg="3" class="text-left">
                  <label for class="mb-0">Filter by Status</label>
                  <b-form-select
                    v-model="requestFilter.status"
                    @change="filterData(2)"
                    id="filter-status"
                  >
                    <option value>Nothing Selected</option>
                    <option
                      v-for="sort in filter.status"
                      :value="sort.key"
                      v-text="sort.name"
                      :key="sort.key"
                      :id="sort.name"
                    ></option>
                  </b-form-select>
                </b-col>
                <b-col lg="3" class="text-left">
                  <label for class="mb-0" id="label-filter-mop"
                    >Filter by Mode of Payment</label
                  >
                  <b-form-select
                    v-model="requestFilter.mop"
                    @change="filterData(2)"
                    id="filter-mop"
                  >
                    <option value>Nothing Selected</option>
                    <option
                      v-for="sort in filter.mop"
                      :value="sort.name"
                      v-text="sort.code"
                      :key="sort.name"
                    ></option>
                  </b-form-select>
                </b-col>
                <b-col lg="3" class="text-left">
                  <label for class="mb-0" id="label-sort-by">Sort by</label>
                  <b-form-select
                    v-model="requestFilter.sort"
                    @change="filterData(2)"
                    id="sort-by"
                  >
                    <option value>Nothing Selected</option>
                    <option
                      v-for="sort in filter.sort"
                      :value="sort.key"
                      v-text="sort.name"
                      :key="sort.key"
                      :id="sort.name"
                    ></option>
                  </b-form-select>
                </b-col>
              </b-row>
            </b-form-group>
          </div>
        </b-container>
      </section>

      <!-- <section
        v-show="isContentShow"
        v-if="searchInvoiceList != ''"
        class="fadein"
      >
        <b-container fluid>
          <div class="customer-info box-shadow mt-2 mb-2 p-4 bg-white">
            <b-form-group>
              <b-row>
                <b-col lg="3" class="text-left">
                  <label for class="mb-0" id="filter-by-date"
                    >Filter by Date</label
                  >
                  <b-form-select
                    v-model="requestFilter.date"
                    @change="filterDataSearch()"
                    id="filter-date"
                  >
                    <option value>Anytime</option>
                    <option
                      v-for="sort in filter.date"
                      :value="sort.key"
                      v-text="sort.name"
                      :key="sort.key"
                      :id="sort.name"
                    ></option>
                  </b-form-select> -->
      <!-- Select date range popup-->
      <!-- <b-modal
                    ref="date-range"
                    hide-footer
                    centered
                    title="Select Date Range"
                  >
                    <div class="d-block">
                      <b-row>
                        <b-col>
                          <label for id="label-start-date">Start Date</label>
                          <datepicker
                            placeholder="Select Date"
                            input-class="form-control"
                            v-model="startDate"
                          ></datepicker>
                        </b-col>
                        <b-col>
                          <label for id="label-end-date">End Date</label>
                          <datepicker
                            placeholder="Select Date"
                            input-class="form-control"
                            v-model="endDate"
                          ></datepicker>
                        </b-col>
                      </b-row>
                    </div>

                    <b-button
                      class="btn grey-btn float-right px-4 mt-4"
                      @click="dateRange()"
                      :disabled="endDate == ''"
                      id="apply-filter-date-range"
                    >
                      <span v-if="$loading == false">Apply Filter</span>
                      <b-spinner small v-if="$loading == true"></b-spinner>
                    </b-button>
                  </b-modal> -->
      <!-- Select spec month popup-->
      <!-- <b-modal
                    ref="spec-month"
                    hide-footer
                    centered
                    title="Select Specific Month"
                  >
                    <div class="d-block">
                      <b-row>
                        <b-col>
                          <label for id="label-select-month"
                            >Select Month</label
                          >
                          <datepicker
                            placeholder="Select Month"
                            input-class="form-control"
                            v-model="specMonth"
                            :minimumView="'month'"
                            :maximumView="'month'"
                          ></datepicker>
                        </b-col>
                      </b-row>
                    </div>

                    <b-button
                      class="btn grey-btn float-right px-4 mt-4"
                      @click="dateRange()"
                      :disabled="specMonth == ''"
                      id="apply-filter-date-range"
                    >
                      <span v-if="$loading == false">Apply Filter</span>
                      <b-spinner small v-if="$loading == true"></b-spinner>
                    </b-button>
                  </b-modal> -->
      <!-- Select spec Year popup-->
      <!-- <b-modal
                    ref="spec-year"
                    hide-footer
                    centered
                    title="Select Specific Year"
                  >
                    <div class="d-block">
                      <b-row>
                        <b-col>
                          <label for id="label-select-year">Select Year</label>
                          <datepicker
                            placeholder="Select Year"
                            input-class="form-control"
                            v-model="specYear"
                            :minimumView="'year'"
                            :maximumView="'year'"
                          ></datepicker>
                        </b-col>
                      </b-row>
                    </div>

                    <b-button
                      class="btn grey-btn float-right px-4 mt-4"
                      @click="dateRange()"
                      :disabled="specYear == ''"
                      id="apply-filter-date-range-year"
                    >
                      <span v-if="$loading == false">Apply Filter</span>
                      <b-spinner small v-if="$loading == true"></b-spinner>
                    </b-button>
                  </b-modal> -->

      <!-- Select spec Day popup-->
      <!-- <b-modal
                    ref="spec-day"
                    hide-footer
                    centered
                    title="Select Specific Day"
                  >
                    <div class="d-block">
                      <b-row>
                        <b-col>
                          <label for id="label-select-day">Select Day</label>
                          <datepicker
                            placeholder="Select Day"
                            input-class="form-control"
                            v-model="specDay"
                            :minimumView="'day'"
                            :maximumView="'day'"
                          ></datepicker>
                        </b-col>
                      </b-row>
                    </div>

                    <b-button
                      class="btn grey-btn float-right px-4 mt-4"
                      @click="dateRange()"
                      :disabled="specDay == ''"
                      id="apply-filter-date-range-day"
                    >
                      <span v-if="$loading == false">Apply Filter</span>
                      <b-spinner small v-if="$loading == true"></b-spinner>
                    </b-button>
                  </b-modal> -->

      <!--<datepicker
                    placeholder="Select..."
                    input-class="form-control"
                    v-model="invoicedate"
                  ></datepicker>-->
      <!-- </b-col> -->
      <!-- <b-col lg="3" class="text-left">
                  <label for class="mb-0" id="filter-by-status"
                    >Filter by Status</label
                  >
                  <b-form-select
                    v-model="requestFilter.status"
                    @change="filterDataSearch()"
                    id="select-filter-status"
                  >
                    <option value>Nothing Selected</option>
                    <option
                      v-for="sort in filter.status"
                      :value="sort.key"
                      v-text="sort.name"
                      :key="sort.key"
                      :id="sort.name"
                    ></option>
                  </b-form-select>
                </b-col>
                <b-col lg="3" class="text-left">
                  <label for class="mb-0" id="label-filter-mop"
                    >Filter by Mode of Payment</label
                  >
                  <b-form-select
                    v-model="requestFilter.mop"
                    @change="filterDataSearch()"
                    id="select-filter-mop"
                  >
                    <option value>Nothing Selected</option>
                    <option
                      v-for="sort in filter.mop"
                      :value="sort.name"
                      v-text="sort.code"
                      :key="sort.name"
                      :id="sort.name"
                    ></option>
                  </b-form-select>
                </b-col>
                <b-col lg="3" class="text-left">
                  <label for class="mb-0" id="label-sort-by">Sort by</label>
                  <b-form-select
                    v-model="requestFilter.sort"
                    @change="filterDataSearch()"
                    id="select-sort-by"
                  >
                    <option value>Nothing Selected</option>
                    <option
                      v-for="sort in filter.sort"
                      :value="sort.key"
                      v-text="sort.name"
                      :key="sort.key"
                      :id="sort.name"
                    ></option>
                  </b-form-select>
                </b-col>
              </b-row>
            </b-form-group> -->
      <!-- </div>
        </b-container>
      </section> -->

      <section>
        <b-container fluid>
          <div class="card mt-1">
            <b-container fluid>
              <b-row class="py-1 px-2 activites-bar">
                <b-col md="1">Type</b-col>
                <b-col md="2">Time</b-col>
                <b-col md="2">Invoice Number</b-col>
                <b-col md="3">Customer Name</b-col>
                <b-col md="2">Mode of Payment</b-col>
                <b-col md="1">Items</b-col>
                <b-col md="1">Balance</b-col>
              </b-row>
              <div
                class="customer-info"
                :class="{
                  'full ': searchInvoiceList == '',
                  'table-height': !state.system.isOffline,
                  'table-height-offline': state.system.isOffline,
                }"
              >
                <div v-if="searchInvoiceList == '' && notFound">
                  <b-row
                    class="py-3 px-4 align-items-center"
                    v-for="item in invoiceList"
                    :key="item.id"
                    :id="item.invoice_no"
                    @click="InvoiceDetail(item)"
                  >
                    <b-col cols="1">
                      <p class="mb-0" v-text="item.transaction_type" />
                    </b-col>
                    <b-col cols="2">
                      <p class="mb-0" v-text="item.date" />
                    </b-col>
                    <b-col cols="2">
                      <p class="mb-0" v-text="item.invoice_no" />
                    </b-col>
                    <b-col cols="3">
                      <p class="mb-0" v-text="item.customer_name" />
                    </b-col>
                    <b-col cols="2">
                      <p class="mb-0" v-text="item.MOP" />
                    </b-col>
                    <b-col cols="1">
                      <p class="mb-0" v-text="item.qty" />
                    </b-col>
                    <b-col cols="1">
                      <p
                        class="mb-0"
                        v-text="currencySymbol + formatAmount(item.total)"
                      />
                    </b-col>
                  </b-row>
                </div>

                <div v-if="searchInvoiceList != '' && search != ''">
                  <b-row
                    class="py-3 px-4 align-items-center"
                    v-for="item in searchInvoiceList"
                    :key="item.id"
                    :id="item.invoice_no"
                    @click="InvoiceDetail(item)"
                  >
                    <b-col cols="1">
                      <p class="mb-0" v-text="item.transaction_type" />
                    </b-col>
                    <b-col cols="2">
                      <p class="mb-0" v-text="item.date" />
                    </b-col>
                    <b-col cols="2">
                      <p class="mb-0" v-text="item.invoice_no" />
                    </b-col>
                    <b-col cols="3">
                      <p class="mb-0" v-text="item.customer_name" />
                    </b-col>
                    <b-col cols="2">
                      <p class="mb-0" v-text="item.MOP" />
                    </b-col>
                    <b-col cols="1">
                      <p class="mb-0" v-text="item.qty" />
                    </b-col>
                    <b-col cols="1">
                      <p class="mb-0" v-text="currencySymbol + item.total" />
                    </b-col>
                  </b-row>
                </div>

                <div
                  v-if="
                    (invoiceList.length === 0 && search == '') ||
                      !notFound ||
                      (invoiceListSearch == 0 && searchedTerm != '')
                  "
                  class="d-flex align-items-center justify-content-center"
                  style="height:100%"
                >
                  <p class="text-muted" v-if="$loading == false">
                    No invoices found.
                  </p>
                </div>
                <!-- <div
                  v-if="search != '' && searchInvoiceList == ''"
                  class="d-flex align-items-center justify-content-center"
                  style="height:100%"
                >
                  <h5 class="fw-normal" v-if="$loading == false">No invoices found.</h5>
                </div>-->
                <div class="clearfix"></div>
                <!-- <div class="text-center">
                  <b-button
                    variant="success"
                    class="grey-outline-btn"
                    @click="loadInvoice()"
                    v-show="invoiceList.length > 9"
                    :disabled="isShow"
                    v-if="searchInvoiceList == ''"
                  >
                    Load More
                    <span v-if="$loading == false"></span>
                    <b-spinner small v-if="$loading == true"></b-spinner>
                  </b-button>
                  <b-button
                    variant="success"
                    class="grey-outline-btn"
                    @click="loadSearchInvoice()"
                    v-show="invoiceList.length > 9"
                    :disabled="isSearchShow"
                    v-if="searchInvoiceList != ''"
                  >
                    Load More
                    <span v-if="$loading == false"></span>
                    <b-spinner small v-if="$loading == true"></b-spinner>
                  </b-button>
                </div> -->
              </div>
            </b-container>
          </div>
        </b-container>
      </section>
      <section>
        <b-container fluid>
          <div
            class="mt-2 d-flex px-2 justify-content-between w-100 align-items-center"
          >
            <div
              :class="[paginationData.total_records == '0' ? 'text-muted' : '']"
            >
              <span
                v-text="
                  `Showing ${totalInvoiceInPage} out of ${paginationData.total_records} entries`
                "
              ></span>
            </div>
            <b-pagination
              class="mb-0"
              :class="[paginationData.total_records == '0' ? 'opacity' : '']"
              v-model="pageNo"
              :total-rows="paginationData.total_records"
              :per-page="paginationData.per_page"
              :limit="6"
              pills
              @change="pageNumber"
              align="right"
            />
          </div>
          <!-- <b-button variant="primary">Load</b-button> -->
        </b-container>
      </section>
    </template>
  </dashboard>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import Dashboard from "../views/Dashboard";
import Loading from "../components/Loading";
import axios from "axios";
import { mapState } from "vuex";
import FilterButton from "../components/FilterButton.vue";

// import * as msg from "../message";

export default {
  name: "invoices",
  components: {
    Dashboard,
    Loading,
    Datepicker,
    FilterButton,
  },
  mounted() {
    this.fetchInvoiceHistory();
  },
  watch: {
    /*  bottom(bottom) {
      if (bottom) {
        this.fetchInvoiceHistory();
      }
    }*/
    search() {
      // if (this.search.length >= 4) {
      //   this.invoiceListSearch();
      //   this.searchInvoicePage = 1;
      // }
      if (this.search == "") {
        this.searchInvoiceList = [];
        this.searchedTerm = "";
        this.notFound = true;
        this.showSearchTerm = false;
        this.isSearchShow = false;
        this.requestFilter = {
          date: {},
          sort: {},
          mop: {},
          status: {},
          filter_format: [],
          date_range: "",
        };
        this.pageNo = 1;
        this.fetchInvoiceHistory();
      }
    },
  },
  created() {
    /*  window.addEventListener("scroll", () => {
      this.bottom = this.bottomVisible();
    });
    this.fetchInvoiceHistory();*/
  },
  computed: {
    ...mapState({
      state: (state) => state,
    }),
    changeDate(dob) {
      return this.$moment(dob).format("MMMM Do YYYY");
    },
    invoiceList() {
      let data = [];
      let result = "";
      //  let invoiceListSearch = "";
      this.Invoices.map((item) => {
        data.push({
          status: item.Status,
          date: item.Cloud_Date,
          invoice_no: item.Order_ID,
          store_name: item.Store_Name,
          MOP: item.MOP,
          customer_name: item.Customer_Name,
          qty: item.Qty,
          total: item.Amount,
          transaction_type: item.Transaction_Type,
          transaction_sub_type: item.Transaction_Sub_Type,
        });
      });

      result = data;
      // if (!this.search) {
      return result;
      // }

      // const filterValue = this.search.toLowerCase();

      // const filter = event =>
      //   event.invoice_no.toLowerCase().includes(filterValue) ||
      //   event.customer_name.toLowerCase().includes(filterValue) ||
      //   event.status.toLowerCase().includes(filterValue);

      // return result.filter(filter);
    },
    getDate() {
      let start_date = "";
      let end_date = "";
      if (this.requestFilter.date.key == "today") {
        start_date = this.$moment().format("YYYY-MM-DD");
        end_date = this.$moment().format("YYYY-MM-DD");
      }
      if (this.requestFilter.date.key == "yesterday") {
        start_date = this.$moment()
          .subtract(1, "days")
          .format("YYYY-MM-DD");
        end_date = this.$moment()
          .subtract(1, "days")
          .format("YYYY-MM-DD");
      }
      if (this.requestFilter.date.key == "last_week") {
        start_date = this.$moment()
          .subtract(7, "days")
          .format("YYYY-MM-DD");
        end_date = this.$moment()
          .subtract(1, "days")
          .format("YYYY-MM-DD");
      }
      if (this.requestFilter.date.key == "specific_day") {
        start_date = this.$moment(this.specDay).format("YYYY-MM-DD");
        end_date = this.$moment(this.specDay).format("YYYY-MM-DD");
      }
      if (this.requestFilter.date.key == "specific_month") {
        start_date = this.$moment(this.specMonth)
          .startOf("month")
          .format("YYYY-MM-DD");
        end_date = this.$moment(this.specMonth)
          .endOf("month")
          .format("YYYY-MM-DD");
      }
      if (this.requestFilter.date.key == "specific_year") {
        start_date = this.$moment(this.specYear)
          .startOf("year")
          .format("YYYY-MM-DD");
        end_date = this.$moment(this.specYear)
          .endOf("year")
          .format("YYYY-MM-DD");
      }
      if (this.requestFilter.date.key == "date_range") {
        start_date = this.$moment(this.startDate).format("YYYY-MM-DD");
        end_date = this.$moment(this.endDate).format("YYYY-MM-DD");
      }
      return { start_date: start_date, end_date: end_date };
    },
    isClearShow() {
      if (
        Object.keys(this.requestFilter.date).length != 0 ||
        Object.keys(this.requestFilter.mop).length != 0 ||
        Object.keys(this.requestFilter.sort).length != 0 ||
        Object.keys(this.requestFilter.status).length != 0 ||
        this.showSearchTerm == true
      )
        return false;
      else return true;
    },
    filterBtnStatus() {
      let temp = true;
      if (
        Object.keys(this.requestFilter.date).length != 0 ||
        Object.keys(this.requestFilter.sort).length != 0 ||
        Object.keys(this.requestFilter.mop).length != 0 ||
        Object.keys(this.requestFilter.status).length != 0
      )
        temp = false;
      return temp;
    },
    dateFilterLabel() {
      let temp = this.requestFilter.date.name;
      if (
        this.requestFilter.date.key == "today" ||
        this.requestFilter.date.key == "yesterday" ||
        this.requestFilter.date.key == "specific_day"
      )
        temp = temp + " [" + this.getDate.start_date + "]";
      if (
        this.requestFilter.date.key == "last_week" ||
        this.requestFilter.date.key == "date_range" ||
        this.requestFilter.date.key == "specific_year" ||
        this.requestFilter.date.key == "specific_month"
      )
        temp =
          temp +
          " [" +
          this.getDate.start_date +
          " : " +
          this.getDate.end_date +
          "]";
      return temp;
    },
  },

  data() {
    return {
      Title: "Invoice History",
      selected: null,
      loading: true,
      searchableName: true,
      isContentShow: false,
      searchedTerm: "",
      Invoices: [],
      // searchInvoices: [],
      searchInvoiceList: "",
      isShow: false,
      isSearchShow: false,
      search: "",
      pageNo: 1,
      // searchInvoicePage: 1,
      startDate: "",
      finalDate: "",
      specDay: "",
      specMonth: "",
      specYear: "",
      endDate: "",
      rangePopup: true,
      invoicedate: "",
      notFound: true,
      showSearchTerm: false,
      totalInvoiceInPage: 0,
      filter: {
        date: [
          {
            key: "today",
            name: "Today",
          },
          {
            key: "yesterday",
            name: "Yesterday",
          },
          {
            key: "last_week",
            name: "Last 7 Days",
          },
          {
            key: "specific_day",
            name: "Day",
          },
          {
            key: "specific_month",
            name: "Month",
          },
          {
            key: "specific_year",
            name: "Year",
          },
          {
            key: "date_range",
            name: "Select Date Range",
          },
        ],
        status: "",
        mop: "",
        sort: "",
      },
      requestFilter: {
        date: {},
        sort: {},
        mop: {},
        status: {},
        filter_format: [],
        date_range: "",
      },
      paginationData: {
        total_records: 0,
        per_page: 0,
      },
    };
  },
  methods: {
    pageNumber(e) {
      if (this.pageNo == e) return;
      this.pageNo = e;
      if (!this.filterBtnStatus) {
        if (this.showSearchTerm) this.filterDataSearch();
        else this.filterData(0);
      } else {
        if (this.showSearchTerm) this.invoiceListSearch();
        else this.fetchInvoiceHistory();
      }
    },
    checkDateFilter() {
      if (
        this.getDate.start_date == "Invalid date" ||
        this.getDate.end_date == "Invalid date"
      )
        this.requestFilter.date = {};
    },
    getFilterData(type, option) {
      if (type == "mop") this.requestFilter.mop = option;
      if (type == "status") this.requestFilter.status = option;
      if (type == "sort") this.requestFilter.sort = option;
      if (type == "date") {
        this.requestFilter.date = option;
        if (this.requestFilter.date.key == "date_range") {
          this.$refs["date-range"].show();
          return;
        }
        if (this.requestFilter.date.key == "specific_month") {
          this.$refs["spec-month"].show();
          return;
        }
        if (this.requestFilter.date.key == "specific_year") {
          this.$refs["spec-year"].show();
          return;
        }
        if (this.requestFilter.date.key == "specific_day") {
          this.$refs["spec-day"].show();
          return;
        }
      }
    },
    searchbar() {
      // console.log(this.search);
      if (this.search != "") {
        this.requestFilter = {
          date: {},
          sort: {},
          mop: {},
          status: {},
          filter_format: [],
          date_range: "",
        };
        this.invoiceListSearch();
        // this.searchInvoicePage = 1;
      }
    },
    bottomVisible() {
      const scrollY = window.scrollY;
      const visible = document.documentElement.clientHeight;
      const pageHeight = document.documentElement.scrollHeight;
      const bottomOfPage = visible + scrollY >= pageHeight;
      return bottomOfPage || pageHeight < visible;
    },
    contentShow(content) {
      this.isContentShow = content;
    },
    fetchInvoiceHistory() {
      this.$loading = true;
      var data = {
        // c_id: this.state.c_id,
        api_token: this.state.sessions.user.api_token,
        v_id: this.state.sessions.user.v_id,
        store_id: this.state.sessions.user.store_id,
        vu_id: this.state.sessions.user.vu_id,
        page: this.pageNo,
        // date_filter: "yesterday",
        //  date_filter:'',
        trans_from: this.state.system.trans_from,
        url: "/my-orders",
        trans_type: "success",
      };
      axios
        .post(data.url, data)
        .then((response) => {
          this.paginationData = response.data.pagination;
          // if (this.pageNo == 1) {
          this.Invoices = response.data.data;
          this.totalInvoiceInPage = response.data.data.length;
          // } else {
          //   let conData = this.Invoices;
          //   conData = conData.concat(response.data.data);
          //   this.Invoices = conData;
          //   this.$loading = false;
          //   // this.loadInvoice(response.data.data);
          // }
          if (response.data.data == "" || response.data.data.length < 10) {
            this.isShow = true;
          }
          this.filter.sort = response.data.sort_type;
          this.filter.mop = response.data.payment_mod;
          this.filter.status = response.data.status_filter;
          this.requestFilter.filter_format = response.data.filter.filter_format;
          this.$loading = false;
        })
        .catch(() => {
          this.$loading = false;
        });
    },
    // loadInvoice() {
    //   this.pageNo += 1;
    //   // this.Invoices.push(data);
    //   this.fetchInvoiceHistory();

    //   // console.log((this.pageNo += 1));
    // },
    // loadSearchInvoice() {
    //   this.searchInvoicePage += 1;
    //   this.invoiceListSearch();
    // },
    filterData() {
      if (this.showSearchTerm) return;
      this.$loading = true;
      var data = {
        // c_id: this.state.c_id,
        api_token: this.state.sessions.user.api_token,
        v_id: this.state.sessions.user.v_id,
        terminal_id: this.state.system.settings.terminal_id,
        store_id: this.state.sessions.user.store_id,
        vu_id: this.state.sessions.user.vu_id,
        trans_from: this.state.system.trans_from,
        transaction_sub_type: this.requestFilter.status.key,
        payment_method: this.requestFilter.mop.name,
        sort: this.requestFilter.sort.key,
        date_filter: this.requestFilter.date.key,
        url: "/my-orders",
        trans_type: "success",
        start_date: this.getDate.start_date,
        end_date: this.getDate.end_date,
        page: this.pageNo,
      };
      axios
        .post(data.url, data)
        .then((response) => {
          this.$loading = false;
          this.paginationData = response.data.pagination;
          this.totalInvoiceInPage = response.data.data.length;
          this.Invoices = response.data.data;
          this.filter.sort = response.data.sort_type;
          this.filter.mop = response.data.payment_mod;
          this.filter.status = response.data.status_filter;
          this.$refs["date-range"].hide();
          this.$refs["spec-month"].hide();
          this.$refs["spec-year"].hide();
          this.$refs["spec-day"].hide();
        })
        .catch(() => {
          this.$loading = false;
        });
    },
    filterDataSearch() {
      if (!this.showSearchTerm) return;
      this.$loading = true;
      let searchInvoices = [];
      let data = [];
      var postdata = {
        // c_id: this.state.c_id,
        api_token: this.state.sessions.user.api_token,
        terminal_id: this.state.system.settings.terminal_id,
        v_id: this.state.sessions.user.v_id,
        store_id: this.state.sessions.user.store_id,
        vu_id: this.state.sessions.user.vu_id,
        trans_from: this.state.system.trans_from,
        transaction_sub_type: this.requestFilter.status.key,
        payment_method: this.requestFilter.mop.name,
        sort: this.requestFilter.sort.key,
        date_filter: this.requestFilter.date.key,
        search_term: this.searchedTerm,
        start_date: this.getDate.start_date,
        end_date: this.getDate.end_date,
        url: "/my-orders",
        trans_type: "success",
        page: this.pageNo,
      };
      axios
        .post(postdata.url, postdata)
        .then((response) => {
          this.$loading = false;
          this.paginationData = response.data.pagination;
          this.totalInvoiceInPage = response.data.data.length;
          //  this.$refs["date-range"].close();
          searchInvoices = response.data.data;
          this.filter.sort = response.data.sort_type;
          this.filter.mop = response.data.payment_mod;
          this.filter.status = response.data.status_filter;
          searchInvoices.map((item) => {
            data.push({
              status: item.Status,
              date: item.Cloud_Date,
              invoice_no: item.Order_ID,
              store_name: item.Store_Name,
              MOP: item.MOP,
              customer_name: item.Customer_Name,
              qty: item.Qty,
              total: item.Amount,
              transaction_type: item.Transaction_Type,
              transaction_sub_type: item.Transaction_Sub_Type,
            });
          });
          this.searchInvoiceList = data;
          this.$loading = false;
        })
        .catch(() => {
          this.$loading = false;
        });
    },
    InvoiceDetail(data) {
      this.$store.commit("billing/setTransactionSubType", "billing");
      let invoice_number = data.invoice_no;
      // console.log(invoice_number);
      if (data.transaction_sub_type != "lay_by") {
        this.$router.push("/order-summary/" + invoice_number);
      } else {
        this.$loading = true;
        console.log("layby");
        var postdata = {
          // c_id: this.state.c_id,
          order_id: invoice_number,
          api_token: this.state.sessions.user.api_token,
          v_id: this.state.sessions.user.v_id,
          store_id: this.state.sessions.user.store_id,
          vu_id: this.state.sessions.user.vu_id,
          terminal_id: this.state.system.settings.terminal_id,
          // udidtoken: this.state.trans_from,
          trans_from: this.state.system.trans_from,
          url: "/vendor/process-lay-by",
        };
        axios
          .post(postdata.url, postdata)
          .then((response) => {
            this.$loading = false;
            this.$store.commit("billing/saveInvoice", response.data);
            this.$router.push("checkout");
          })
          .catch(() => {
            this.$loading = false;
          });
      }
    },
    searchByVal(data) {
      this.search = data;
    },

    dateRange() {
      this.$loading = false;
      let date;
      // For date range
      if (this.requestFilter.date == "date_range") {
        let start_date = this.$moment(this.startDate).format("YYYY-MM-DD"),
          end_date = this.$moment(this.endDate).format("YYYY-MM-DD");
        date = start_date + "/date_range/" + end_date;
      }
      if (this.requestFilter.date == "specific_month") {
        let spec_month = this.$moment(this.specMonth).format("MM-YYYY");
        let split = spec_month.split("-");
        date = split[0] + "/specific_month/" + split[1];
      }
      if (this.requestFilter.date == "specific_year") {
        let spec_year = this.$moment(this.specYear).format("YYYY");
        date = spec_year + "/specific_year/";
      }
      if (this.requestFilter.date == "specific_day") {
        let spec_day = this.$moment(this.specDay).format("YYYY-MM-DD");
        date = spec_day + "/specific_day/";
        // console.log(spec_day);
      }
      // if(this.requestFilter.date == "specific_year"){
      //  date = this.$moment(this.specYear).format("YYYY");
      // }

      this.finalDate = date;
      // console.log(this.finalDate);
      var data = {
        // c_id: this.state.c_id,
        api_token: this.state.sessions.user.api_token,
        v_id: this.state.sessions.user.v_id,
        store_id: this.state.sessions.user.store_id,
        vu_id: this.state.sessions.user.vu_id,
        date_filter: this.finalDate,
        url: "/my-orders",
        trans_type: "success",
      };

      axios
        .post(data.url, data)
        .then((response) => {
          this.$loading = false;
          this.paginationData = response.data.pagination;
          this.totalInvoiceInPage = response.data.data.length;
          this.Invoices = response.data.data;
          this.filter.sort = response.data.sort_type;
          this.filter.mop = response.data.payment_mod;
          this.filter.status = response.data.status_filter;
          this.$refs["date-range"].hide();
          this.$refs["spec-month"].hide();
          this.$refs["spec-year"].hide();
          this.$refs["spec-day"].hide();
          this.endDate = "";
          this.startDate = "";
        })
        .catch(() => {
          this.$loading = false;
        });
    },
    clearSearch() {
      this.search = "";
      this.searchedTerm = "";
      this.notFound = true;
      this.showSearchTerm = false;
      this.isSearchShow = false;
      this.requestFilter.date = "";
      this.requestFilter.mop = {};
      this.requestFilter.sort = {};
      this.requestFilter.status = {};
      this.pageNo = 1;
      this.fetchInvoiceHistory();
    },
    invoiceListSearch() {
      let data = [];
      let searchInvoices = [];
      this.$loading = true;
      var postdata = {
        // c_id: this.state.c_id,
        api_token: this.state.sessions.user.api_token,
        v_id: this.state.sessions.user.v_id,
        // store_id: this.state.sessions.user.store_id,
        vu_id: this.state.sessions.user.vu_id,
        page: this.pageNo,
        search_term: this.search,
        trans_from: this.state.trans_from,
        url: "/my-orders",
        trans_type: "success",
      };
      if (this.search == "") {
        postdata.store_id = this.state.sessions.user.store_id;
      }
      if (typeof this._source != typeof undefined) {
        this._source.cancel("Operation canceled due to new request.");
      }

      this._source = axios.CancelToken.source();
      axios
        .post(postdata.url, postdata, { cancelToken: this._source.token })
        .then((response) => {
          this.paginationData = response.data.pagination;
          this.totalInvoiceInPage = response.data.data.length;
          this.searchedTerm = this.search;
          this.showSearchTerm = true;
          // if (this.searchInvoicePage == 1) {
          searchInvoices = response.data.data;
          searchInvoices.map((item) => {
            data.push({
              status: item.Status,
              date: item.Cloud_Date,
              invoice_no: item.Order_ID,
              store_name: item.Store_Name,
              MOP: item.MOP,
              customer_name: item.Customer_Name,
              qty: item.Qty,
              total: item.Amount,
              transaction_type: item.Transaction_Type,
              transaction_sub_type: item.Transaction_Sub_Type,
            });
          });
          this.searchInvoiceList = data;
          this.$loading = false;
          // } else {
          //   let conData = this.searchInvoiceList;
          //   searchInvoices = response.data.data;
          //   searchInvoices.map((item) => {
          //     data.push({
          //       status: item.Status,
          //       date: item.Cloud_Date,
          //       invoice_no: item.Order_ID,
          //       store_name: item.Store_Name,
          //       MOP: item.MOP,
          //       customer_name: item.Customer_Name,
          //       qty: item.Qty,
          //       total: item.Amount,
          //       transaction_type: item.Transaction_Type,
          //       transaction_sub_type: item.Transaction_Sub_Type,
          //     });
          //   });

          //   conData = conData.concat(data);
          //   console.log(conData);
          //   this.searchInvoiceList = conData;
          //   this.$loading = false;
          // }
          if (response.data.data == "" || response.data.data.length < 10) {
            this.isSearchShow = true;
          }
          if (response.data.data == "") {
            this.notFound = false;
            this.pageNo = 1;
            // this.search = "";
            // this.searchInvoiceList = "";
            // this.searchInvoicePage = 1;
            // let alertData = {
            //   message: msg.INVALID_SEARCH_TERM,
            //   type: "danger"
            // };
            // this.$showAlert = true;

            // // this.$store.commit("resetAlert");
            // this.$store.commit("showAlert", alertData);
          }
          this.filter.sort = response.data.sort_type;
          this.filter.mop = response.data.payment_mod;
          this.filter.status = response.data.status_filter;
          this.requestFilter.filter_format = response.data.filter.filter_format;
        })
        .catch(() => {
          this.$loading = false;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.opacity {
  opacity: 0.4;
}
.theme-dark .customer-info {
  background-color: #202020 !important;
  border-bottom: 1px solid #404040;
  .custom-select {
    border: none !important;
  }
}

.customer-info {
  overflow-x: hidden;
  overflow-y: auto;
  margin-left: -15px;
  margin-right: -15px;
  @include custom-scrollbar();
  .row {
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    cursor: pointer;
  }
}

.custom-select {
  font-size: 13px;
}

.theme-light .table-dark-bg {
  background: $grey-btn-bg;
  // height: calc(100vh - 156px);
  overflow-x: hidden;
  overflow-y: auto;
  @include custom-scrollbar();
}
// .theme-light .table-dark-bg.full,
// .theme-dark .table-dark-bg.full {
// height: calc(100vh - 156px);
// }
.theme-dark .table-dark-bg {
  // height: calc(100vh - 156px);
  overflow-x: hidden;
  overflow-y: auto;
  @include custom-scrollbar();
}
.table-height {
  height: calc(100vh - 172px);
}
.table-height-offline {
  height: calc(100vh - 130px);
}
.vdp-datepicker input {
  height: calc(2.55rem + 0px);
}

h4 {
  color: $mid-grey;
}
h5 {
  color: $grey-color;
}
.lay-by.pill {
  &:before {
    background: #17a2b8;
  }
}
.completed.pill {
  &:before {
    background: $success-btn;
  }
}
.return.pill {
  &:before {
    background: $blue-color;
  }
}
.completed h6 span {
  color: $success-btn;
}
.search-term-badge {
  font-weight: normal;
  font-size: 12px;
}
.header-elements .form-control:focus {
  background-color: #fff !important;
  border: 1px transparent !important;
}
.filter-dropdown {
  padding: 0;
}
.filter-dropdown {
  li {
    list-style: none;
  }
}
</style>
